
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
// import { OrderServiceStage, ViewType } from '@/types/orderServicer';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import SelectParts from '../order/components/OrderParts.vue';
import OrderTag from '../order/components/OrderTag.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import DialogOrderDetail from '@/components/OrderDetail/index.vue';
import InputDialog from '@/components/InputDialog/InputDialog.vue';
import SelectFaultDialog from '@/components/SelectFaultDialog/index.vue';
import {
  getOrderDispose,
  orderAssign,
  orderTransfer,
  assignOrders,
  orderFinish,
  transferOrders,
  addAppointmentTime,
  expedited,
  getOrderServiceProgressList,
  diyContent,
  orderCheck
} from '@/api/orderService';
import {
  deleteProduct,
  deleteParts,
  addImage,
  deleteImage,
  addVideo,
  deleteVideo,
  addPrice,
  deletePrice,
  deleteFault,
  addRemark,
  deleteRemark,
  deleteDevice,
  deleteTags,
  addWord,
  deleteWord
} from '@/api/order';
import { getDepartmentList } from '@/api/company';
import { getWorkUser } from '@/api/users';
import { getPrice } from '@/api/other';
import { getService } from '@/api/service';
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionRole,
  getModelPermission,
  checkServerAppointmentTimeIsMust,
  checkServerAppointmentTime,
  checkTaskCoordinationVisble
} from '@/utils/permission';

import { makeKey } from '@/utils/qiniu';
import { imageType } from '@/types/imageType';
import { remarkType } from '@/types/remarkType';
import { limit } from '@/types/limit';
import { isEmpty, parseTime } from '@/utils/index';
import { ModuleType, ViewType, Type } from '@/types/permissionType';

@Component({
  name: 'orderServicerTodeal',
  components: {
    DialogImgLarge,
    SelectParts,
    OrderTag,
    OrderBrand,
    OrderDevice,
    DialogOrderDetail,
    InputDialog,
    SelectFaultDialog
  }
})
export default class extends Vue {
  private tableData: any = [];
  private limit: any = limit;
  private first='first'

  private formInformation: any = {
    appointment: '',
    expedited: false,
    tag: '',
    tags: '',
    brand: '',
    brandstr: '',
    device: '',
    parts: '',
    image: [],
    video: [],
    word: [],

    costType: '',
    costValue: '',
    remark: '',
    order_task_list: []
  };
  private dynamicRemark: any = [];
  private dynamicFault: any = [];
  private dynamicCost: any = [];

  private costList: any = [];
  private partsVisible = false;
  private companyId = '';
  private tagVisible = false;
  private servicer: any = {};
  private brandVisible = false;
  private deviceId = '';
  private deviceVisible = false;

  private orderServiceId = '';

  private orderDetail: any = {
    order: {}
  };
  private tags: any = [];

  private qiniu: any;
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private form: object = {};
  private defaultUrl = '';

  private userDeptList: any = [];
  private selectUserDept: any = {};

  private productModelPermission: any = { v: 0 };
  private deviceModelPermission: any = { v: 0 };
  private partsModelPermission: any = { v: 0 };
  private remarkModelPermission: any = { v: 0 };
  private faultkModelPermission: any = { v: 0 };
  private costModelPermission: any = { v: 0 };
  private picModelPermission: any = { v: 0 };
  private videoModelPermission: any = { v: 0 };
  private tagModelPermission: any = { v: 0 };
  private appointmentTimeVisibility = false;
  private appointmentTimeMust = false;

  private diyOneModelPermission: any = { v: 0 };
  private diyTwoModelPermission: any = { v: 0 };

  private wordModelPermission: any = { v: 0 };

  private assignSelf=false;
  private assignOrder=false;
  private turnOrder=false;
  private orderConfirmCustomer=false;

  private isSendOrderToEng:number=0; // 1 工程师派单-已经选择工程师进入订单  2 批量处理订单
  private eng:any={}
  private sendAllToEngDept:any=''
  private orderId=''

  private isEditSendToEng:any=0; // 1 工程师派单-编辑保存

  created() {
    if (this.$route.query.isEditSendToEng) {
      this.isEditSendToEng = parseInt(this.$route.query.isEditSendToEng as string);
    } else {
      this.isEditSendToEng = 0;
    }

    if (UserModule.getUserDeptList) {
      this.userDeptList = UserModule.getUserDeptList.filter((bean:any) => {
        return parseInt(bean.dept_type) === 2;
      });
    }
    this.orderConfirmCustomer = this.$route.query.isFinshCustomer === '1';
    this.orderServiceId = this.$route.query.order_service_id as any;
    this.companyId = this.$route.query.company_id as any;
    if (this.$route.query.isSendOrderToEng) {
      this.isSendOrderToEng = parseInt(this.$route.query.isSendOrderToEng as string);
    } else {
      this.isSendOrderToEng = 0;
    }
    if (this.isSendOrderToEng !== 0) {
      if (this.$route.query.OrderList) {
        this.tableData = JSON.parse(this.$route.query.OrderList as string);
        this.companyId = this.tableData[0].order_service.servicer_company_id;
        this.setPermission(0, this.tableData[0].order.order_type);
      }
      if (this.$route.query.eng) {
        this.eng = JSON.parse(this.$route.query.eng as string);
        if (this.eng && this.eng.dept_list && this.eng.dept_list.length === 1) {
          this.sendAllToEngDept = this.eng.dept_list[0];
        }
      }
    } else {
      this.getOrderDispose();
    }
  }
  private back() {
    this.$router.back();
  }
  // 指派工程师 批量处理
  private sendAllToEng() {
    let serviceId = [];
    for (const key of this.tableData) {
      serviceId.push(key.order_service.id);
    }
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId
    };
    params.order_service_id = JSON.stringify(serviceId);
    params.work_user = JSON.stringify({
      user_id: this.eng.user_id,
      name: this.eng.user_name
    });

    if (this.sendAllToEngDept && this.sendAllToEngDept.id) {
      params.work_department_id = this.sendAllToEngDept.id;
      params.work_department_name = this.sendAllToEngDept.name;
    }
    assignOrders(params).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.$router.go(-1);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private getOrderDispose() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: this.orderServiceId
    };
    getOrderDispose(params)
      .then((res: any) => {
        if (res.data) {
          this.orderDetail = res.data;
          this.qiniu = this.orderDetail.uptoken;
          this.orderId = this.orderDetail.order.id;
          this.tableData = [];
          this.tableData.push(this.orderDetail);
          var temp = '';
          if (this.orderDetail.order.order_brand) {
            temp =
              this.isNull(this.orderDetail.order.order_brand.brand_name) +
              '/' +
              this.isNull(this.orderDetail.order.order_brand.product_name) +
              '/' +
              this.isNull(this.orderDetail.order.order_brand.model_name) +
              '/' + this.isNull(this.orderDetail.order.order_brand.amount);
          }
          if (this.orderDetail.order.parts_list) {
            for (var bean of this.orderDetail.order.parts_list) {
              bean.str =
                this.isNull(bean.parts_name) +
                '/' +
                this.isNull(bean.parts_model_name) +
                '/' +
                this.isNull(bean.parts_amount) +
                '/' +
                this.isNull(bean.parts_unit_price) +
                '/' +
                this.isNull(bean.parts_price) +
                '/' +
                this.isNull(bean.parts_attribute_name);
            }
          }
          if (this.orderDetail.order_service.video_list) {
            for (var bean2 of this.orderDetail.order_service.video_list) {
              bean2.img_url = bean2.full_path;
            }
          }
          this.dynamicCost = this.orderDetail.order.order_price;
          this.dynamicFault = this.orderDetail.order.fault_list;
          this.dynamicRemark = this.orderDetail.order.order_remark;

          this.formInformation.tags = this.orderDetail.order.tags;
          this.formInformation.brand = this.orderDetail.order.order_brand;
          this.formInformation.brandstr = temp;
          this.formInformation.device = this.orderDetail.order.order_device;
          this.formInformation.parts = this.orderDetail.order.parts_list;
          this.formInformation.image = this.orderDetail.order.order_image;
          this.formInformation.video = this.orderDetail.order_service.video_list;
          if (this.orderDetail.order_service.document_list) {
            this.formInformation.word = this.orderDetail.order_service.document_list;
          } else {
            this.formInformation.word = [];
          }
          if (this.formInformation.word) {
            this.formInformation.word.map(function(item:any) {
              item.name = item.original_name;
            });
          }
          this.formInformation.order_task_list = this.orderDetail.order_task_list;
          if (this.orderDetail.order_service.servicer_appointment_timestamp && parseInt(this.orderDetail.order_service.servicer_appointment_timestamp) !== 0) {
            this.formInformation.appointment = this.orderDetail.order_service.servicer_appointment_timestamp + '000';
          }
          this.$set(this.formInformation, 'expedited', parseInt(this.orderDetail.order_service.expedited) === 1);
          var dealType = 0;
          this.appointmentTimeVisibility = checkServerAppointmentTime(
            this.orderDetail.order.order_type,
            this.companyId
          );
          this.appointmentTimeMust = checkServerAppointmentTimeIsMust(this.orderDetail.order.order_type, this.companyId);
          if (this.orderDetail.order_task != null) {
            dealType = this.orderDetail.order_task.deal_type;
          }
          this.taskCoordinationDisabled = parseInt(this.orderDetail.order_service.is_assign_other_task_complete) === 1 || parseInt(this.orderDetail.order_service.state) > 220
          this.taskCoordinationVisble = checkTaskCoordinationVisble(this.orderDetail.order.order_type, this.companyId)
          this.setPermission(dealType, this.orderDetail.order.order_type);
          this.configCheck();
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private setPermission(dealType: any, orderType:any) {
    this.assignSelf = checkPermissionCompanyFromOrderType(this.companyId, Type.ORDER_ASSIGN_SELF, orderType) && checkPermissionRole(this.companyId, Type.ORDER_ASSIGN_SELF);
    this.assignOrder = checkPermissionCompanyFromOrderType(this.companyId, Type.ORDER_ASSIGN, orderType) && checkPermissionRole(this.companyId, Type.ORDER_ASSIGN);
    this.turnOrder = checkPermissionCompanyFromOrderType(this.companyId, Type.ORDER_TRANSFER, orderType) && checkPermissionRole(this.companyId, Type.ORDER_TRANSFER);
    if (this.assignSelf) {
      this.activeAssignName = 'first';
    } else if (this.assignOrder) {
      this.activeAssignName = 'second';
      this.getDepartmentList(1);
    } else if (this.turnOrder) {
      this.activeAssignName = 'third';
    } else {
      this.activeAssignName = '';
    }
    this.productModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_PRODUCT,
      orderType
    );
    this.deviceModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEVICE,
      orderType
    );
    this.partsModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_PARTS,
      orderType
    );
    this.remarkModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_REMARK,
      orderType
    );
    this.diyOneModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DIY_ONE,
      orderType
    );
    this.wordModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_WORD_FILE,
      orderType
    );
    this.diyTwoModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DIY_TWO,
      orderType
    );
    this.faultkModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_FAULTTYPE,
      orderType
    );
    this.costModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_COST,
      orderType
    );
    this.picModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEAL_IMAGE,
      orderType
    );
    this.videoModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEAL_VIDEO,
      orderType
    );
    this.tagModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_TAG,
      orderType
    );
  }

  private setPermissionWithType(dealType: any, moduleType: ModuleType, orderType:any) {
    return getModelPermission(
      ViewType.DEAL_ORDER,
      orderType,
      dealType,
      this.companyId,
      moduleType
    );
  }
  private checkDealPermission(p:any) {
    if (!checkPermissionRole(this.companyId, p)) {
      this.$alert('', '您没有该订单处理权限', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return false;
    } else {
      return true;
    }
  }

  private isNull(val: any) {
    if (val) {
      return val;
    } else {
      return '~';
    }
  }
  // 预约时间
  private appointmentChange(val:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      order_service_id: this.orderDetail.order_service.id,

      servicer_appointment_time: val / 1000 };
    if (this.orderId) {
      pamars.order_id = this.orderId;
    }
    addAppointmentTime(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.getOrderDispose();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 加急
  private expeditedCheckbox(val:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      id: this.orderDetail.order_service.id,
      expedited: val ? '1' : '0' };
    expedited(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.getOrderDispose();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private selectDeviceHandle() {
    this.deviceVisible = true;
  }
  private closeDeviceHandle(val: boolean) {
    this.deviceVisible = val;
  }
  // 品牌 显示品牌dialog
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  // 品牌 关闭品牌dialog
  private closeBrandHandle(val: boolean) {
    this.brandVisible = val;
  }
  // 品牌 选择品牌
  private confirmBrandHandle(val: any) {
    this.showSuccessMsg('添加成功');
    this.formInformation.brandstr =
      this.isNull(val.brand_name) +
      '/' +
      this.isNull(val.product_name) +
      '/' +
      this.isNull(val.model_name);
    this.formInformation.brand = val;
  }
  // 删除现有的品牌
  private deleteBrandHandle(id: any) {
    const params: any = {
      id: id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteProduct(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        this.formInformation.brand = '';
        this.formInformation.brandstr = '';
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 标签 显示dialog
  private selectTag() {
    if (parseInt(this.orderDetail.order.order_check_tag_is_pass) === 1) {
      if (this.$refs.inputTag) {
        (this.$refs.inputTag as any).blur();
      }
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    if (
      this.formInformation.tags &&
      this.formInformation.tags.length >= limit.ORDER_SERVICE_ADD_TAG
    ) {
      this.showErrorMsg('您最多选择' + limit.ORDER_SERVICE_ADD_TAG + '个标签');
      return;
    }
    this.tagVisible = true;
  }
  // 标签 关闭dialog
  private closeTagHandle(val: boolean) {
    this.tagVisible = val;
  }
  // 标签 选择标签
  private confirmTagHandle(val: any) {
    this.tagVisible = false;
    this.getOrderDispose();
  }
  // 标签 删除标签
  private handleCloseTags(val: any) {
    if (parseInt(this.orderDetail.order.order_check_tag_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    const params: any = {
      tags_id: val.tags_id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    // if (this.orderDetail.order_service) {
    //   params.order_service_id = this.orderDetail.order_service.id;
    // }
    // if (this.orderDetail.order_task) {
    //   params.order_task_id = this.orderDetail.order_task.id;
    // }
    deleteTags(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 选择别备件
  private selectPartsHandle() {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass) === 1) {
      if (this.$refs.inputParts) {
        (this.$refs.inputParts as any).blur();
      }
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: function() {

        }
      });
      return;
    }
    this.partsVisible = true;
    this.companyId = UserModule.getCompanyId;
  }
  // 关闭选择备件弹窗
  private closeParts(val: boolean) {
    this.partsVisible = val;
  }
  // 添加备件完成
  private confirmParts(val: any) {
    this.partsVisible = false;
    // val.str = this.isNull(val.parts_name) +
    //           '/' + this.isNull(val.parts_model_name) +
    //           '/' + this.isNull(val.parts_amount) +
    //           '/' + this.isNull(val.parts_unit_price) +
    //           '/' + this.isNull(val.parts_price) +
    //           '/' + this.isNull(val.parts_attribute_name);
    // (this.formInformation.parts as any).push(val);
    this.showSuccessMsg('添加成功');
    this.getOrderDispose();
  }
  // 删除备件
  private deletePartsHandle(val: any) {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    if (val.already_charge_off_num && parseInt(val.already_charge_off_num) !== 0) {
      this.showErrorMsg('备件已核销不能删除');
      return;
    }
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteParts(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private confirmDeviceHandle() {
    this.showSuccessMsg('添加成功');
    this.getOrderDispose();
  }

  // 删除设备
  private deleteDeviceHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteDevice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 上传图片准备
  private beforeUploadUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M =
      file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error(
        '上传图片大小不能超过 ' + limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE + 'MB!'
      );
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  // 上传图片成功
  private handleUploadSuccess(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      save_path: val.key,
      image_type: imageType.ORDER_SERVICE_IMG_DISPOSE
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addImage(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        let arr = [];
        arr.push({
          id: res.data.id,
          img_url: this.qiniu.default_url + val.key,
          image: val.key
        });
        if (this.formInformation.image) {
          this.formInformation.image = this.formInformation.image.concat(arr);
        } else {
          this.formInformation.image = arr;
        }
      })
      .catch((err: any) => {
        let msg = err.msg;
        // this.showErrorMsg(err.msg);
      });
  }
  // 从订单删除图片
  private deleteImgHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteImage(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 上传视频
  private handleUploadSuccessVideo(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      save_path: val.key,
      video_type: imageType.ORDER_SERVICE_IMG_DISPOSE
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addVideo(params)
      .then((res: any) => {
        // this.formInformation.video.push({
        //   id: res.data.id,
        //   img_url: this.qiniu.default_url + val.key,
        //   image: val.key
        // });
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除视频
  private deleteVideoHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteVideo(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 上传视频准备
  private beforeUploadUploadVideo(file: any) {
    const isJPG = file.type === 'video/mp4';
    const isLt2M =
      file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  mp4 格式!');
    }
    if (!isLt2M) {
      return this.$message.error(
        '上传图片大小不能超过 ' + limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE + 'MB!'
      );
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey) + '.mp4';
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  // 文档
  private uploadSuccessDocument(res:any, file:any, fileList:any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      type: imageType.ORDER_SERVICE_IMG_DISPOSE
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    let arr = [];
    arr.push({
      original_name: file.name,
      save_path: res.key
    });
    params.document = JSON.stringify(arr);
    addWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private beforeUploadDocument(file:any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }
  private onExceed() {
    this.$message.error('最多上传4个文档');
  }
  private onRemove(file:any, fileList:any) {
    const params: any = {
      id: file.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 费用选中 设置金额
  private selectCost(val: any) {
    this.formInformation.costValue = val.price_num;
  }
  // 添加费用
  private costItemVisibility = false
  private priceClick() {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    this.costItemVisibility = true;
  }
  private addCostHandle(type: any, cost: any) {
    if (!type) {
      this.showErrorMsg('请选择费用类型');
      return;
    }
    var temp = {
      price_id: type.id,
      price_name: type.price_name,
      price_num: cost
    };
    var arr = [];
    arr.push(temp);
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      price: JSON.stringify(arr)
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addPrice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.costItemVisibility = false;
        this.formInformation.costValue = '';
        this.formInformation.costType = '';
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除费用
  private removeCostHandle(v: any) {
    if (parseInt(this.orderDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deletePrice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 获取费用类表
  private getPrice() {
    if (this.costList.length === 0) {
      const params = {
        user_id: UserModule.getUserId,
        company_id: this.companyId
      };
      getPrice(params)
        .then((res: any) => {
          this.costList = res.data.list;
        })
        .catch((err: any) => {
          this.showErrorMsg(err.msg);
        });
    }
  }

  // 添加故障类型
  private faultItemVisibility:any = false;
  private comfirmSelectFault(val:any) {
    this.faultItemVisibility = val;
    this.getOrderDispose();
  }
  private closeSelectFaultDialog(val:any) {
    this.faultItemVisibility = val;
  }

  // 删除故障类型
  private removeFaultHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteFault(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 添加备注 自定义 弹窗
  private inputDialogVisibility = false
  private inputDialogEnterType:number=0;
  private inputDialogContent:string=''

  private inputDialogComfirmHandle(val:string, val2:any) {
    switch (this.inputDialogEnterType) {
      case 0:
        if (isEmpty(val.trim())) {
          this.showErrorMsg('请填写备注');
          return;
        }
        this.addRemark(val, val2);
        break;
      case 1:
        this.addDiy(val, 'diy_one_content');
        break;
      case 2:
        this.addDiy(val, 'diy_two_content');
        break;
    }
  }
  private inputDialogClose(val:boolean) {
    this.inputDialogVisibility = val;
  }

  private remarkAddHandle() {
    this.inputDialogContent = '';
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = 0;
  }

  private addRemark(remark:string, val:any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      remark_type: remarkType.ORDER_SERVICE_DISPOSE,
      remark: remark
    };
    if (val && val.id) {
      params.classify_id = val.id;
      params.classify_name = val.name;
    }
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addRemark(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除备注
  private removeRemarkHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    deleteRemark(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 自定义
  private diyOneAddHandle(val:number) {
    if (val === 1) {
      this.inputDialogContent = this.orderDetail.order.diy_one_content;
    } else {
      this.inputDialogContent = this.orderDetail.order.diy_two_content;
    }
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = val;
  }
  private addDiy(content:string, field:string) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      edit_value: content,
      edit_field: field
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    diyContent(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.getOrderDispose();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  //= ================================处理操作=================================
  private selectAssignType = '1';
  private btnShow: any = true;
  private unfinishOrderTaskNum: any = 0;
  private unfinishOrderTaskVisibility: any = false;

  private handleClick(tab: any, event: any) {
    switch (tab.name) {
      case 'first':
        this.btnShow = true;
        break;
      case 'second':
        this.btnShow = true;
        this.getDepartmentList(1);
        break;
      case 'third':
        this.btnShow = true;
        break;
    }
  }

  private deptPageCount: any = 1;
  private deptPage: any = 1;
  private deptMore() {
    this.getDepartmentList(this.deptPage + 1);
  }

  private selfChange(val:any) {
    this.assignSelectedDept = {};
    this.assignSelected = '';
    this.assignchecked = [];
    this.assignSelectServiceTableData = [];
    this.getDepartmentList(1);
  }

  private getDepartmentList(page: any) {
    if (parseInt(this.selectAssignType) === 1) {
      this.getSelfDepartmentList(page, '2');
    } else {
      this.getSelfDepartmentList(page, '9');
    }
  }

  private getSelfDepartmentList(page: any, dtype:any) {
    this.deptPage = page;
    const params: any = {
      page: page,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      type: dtype, // 部门类型 1报修部门 2服务部门 3审批部门 9所有部门 (必填)
      dept_type: 2 // 部门类型 1报修部门 2服务部门
      // order_id: this.orderId
    };
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.tableData) {
      let serviceIDs: any = '';
      for (const item of this.tableData) {
        serviceIDs = serviceIDs + item.order_service.id + ',';
      }
      params.order_service_id = serviceIDs.substring(0, serviceIDs.length - 1);
    }

    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    getDepartmentList(params)
      .then((res: any) => {
        if (res.data) {
          if (this.deptPage === 1) {
            this.assignSelectTableData = res.data.list;
          } else {
            this.assignSelectTableData = this.assignSelectTableData.concat(res.data.list);
          }
          if (this.assignSelectTableData && this.assignSelectTableData.length === 1) {
            this.assignSelectedDept = this.assignSelectTableData[0];
            this.assignSelected = this.assignSelectTableData[0].id;
            this.getWorkUser(1);
          }
          this.deptPageCount = res.data.page_count;
        } else {
          if (this.deptPage === 1) {
            this.assignSelectTableData = [];
            this.deptPageCount = 1;
          }
        }
      })
      .catch((err: any) => {
        this.assignSelectTableData = [];
        this.deptPageCount = 1;
        this.showErrorMsg(err.msg);
      });
  }

  private workUserPageCount: any = 1;
  private workUserPage: any = 1;
  private workUserMore() {
    this.workUserPage = this.workUserPage + 1;
    this.getWorkUser(this.workUserPage);
  }

  private assignSelectedDept: any = {};

  private selectDept(val: any) {
    this.assignSelectedDept = val;
    this.getWorkUser(1);
  }

  private getWorkUser(page: any) {
    const params: any = {
      dept_id: this.assignSelected,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      page: page,
      size: 10
    };
    if (this.orderId) {
      params.order_id = this.orderId;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    getWorkUser(params)
      .then((res: any) => {
        if (res.data) {
          if (page === 1) {
            this.assignSelectServiceTableData = res.data.list;
          } else {
            this.assignSelectServiceTableData = this.assignSelectServiceTableData.concat(res.data.list);
          }
          this.workUserPageCount = res.data.page_count;
        } else {
          if (page === 1) {
            this.assignSelectServiceTableData = [];
            this.workUserPageCount = 1;
          }
        }
      })
      .catch((err: any) => {
        if (page === 1) {
          this.assignSelectServiceTableData = [];
          this.workUserPageCount = 1;
        }
        let msg = err.msg;
      });
  }

  private serviceList: any = [];

  private getService() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      page: 1,
      size: 100
    };
    getService(params)
      .then((res: any) => {
        if (res.data) {
          this.serviceList = res.data.list;
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private workDepartmentId: any;
  private workDepartmentName: any;

  private assign() {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      expedited: this.formInformation.expedited ? '1' : '0',
      company_id: this.companyId
    };
    if (this.isSendOrderToEng === 2) {
      // 东改 批量处理订单
      let serviceIDs: any = [];
      for (const item of this.tableData) {
        serviceIDs.push(item.order_service.id);
      }
      params.order_service_id = JSON.stringify(serviceIDs);
      params.is_new_home = '1'; // 新后台处理标识 因为同样的接口字段work_user APP使用map(先选人后选单-工程师派单)  新后台用list(既有先选人后选单-工程师派单  也有先选单后选人-批量处理订单)
    } else {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    switch (this.activeAssignName) {
      case 'first':
        if (!this.checkDealPermission(Type.ORDER_ASSIGN_SELF)) {
          return;
        }
        if (this.isSendOrderToEng === 2) { // 批量处理订单
          if (this.userDeptList && this.userDeptList.length > 0) {
            if (!this.selectUserDept || !this.selectUserDept.id) {
              this.showErrorMsg('请选择部门');
              return;
            }
          }
          let workUser:any = {
            user_id: UserModule.getUserId,
            user_name: UserModule.getUserName
          };
          if (this.selectUserDept.id) {
            workUser.dept_id = this.selectUserDept.id;
            workUser.dept_name = this.selectUserDept.name;
          }
          let arr:any = [];
          arr.push(workUser);
          params.work_user = JSON.stringify(arr);
          assignOrders(params)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.$router.go(-1);
            })
            .catch((err: any) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          if ((!this.formInformation || !this.formInformation.appointment) && this.appointmentTimeMust) {
            this.showErrorMsg('请选择预约时间');
            return;
          }
          if (this.checkMust()) {
            // params.servicer_appointment_time = this.formInformation.appointment / 1000;
            if (this.userDeptList && this.userDeptList.length > 0) {
              if (!this.selectUserDept || !this.selectUserDept.id) {
                this.showErrorMsg('请选择部门');
                return;
              }
            }
            let workUser:any = {
              user_id: UserModule.getUserId,
              user_name: UserModule.getUserName
            };
            if (this.selectUserDept.id) {
              workUser.dept_id = this.selectUserDept.id;
              workUser.dept_name = this.selectUserDept.name;
            }
            let arr:any = [];
            arr.push(workUser);
            params.work_user = JSON.stringify(arr);
            if (this.taskCoordinationVisble) {
              params.is_assign_other_task_complete = this.taskCoordination ? '1' : '0'
            }
            orderAssign(params)
              .then((res: any) => {
                this.showSuccessMsg(res.msg);
                this.$router.go(-1);
              })
              .catch((err: any) => {
                this.showErrorMsg(err.msg);
              });
          }
        }
        break;
      case 'second':
        if (!this.checkDealPermission(Type.ORDER_ASSIGN)) {
          return;
        }
        if (this.isSendOrderToEng === 2) { // 批量处理订单
          switch (parseInt(this.selectAssignType)) {
            // 派单工程师
            case 1:
              if (!this.assignSelectedDept.name) {
                this.showErrorMsg('请选择部门');
                return;
              }
              if ((this.assignchecked as any).length <= 0) {
                this.showErrorMsg('请选择工程师');
                return;
              }
              var userList: any = [];
              for (const assign of this.assignchecked) {
                let assingBean = {
                  user_id: assign.user.user_id,
                  name: assign.user.name,
                  dept_id: assign.dept_id ? assign.dept_id : '',
                  dept_name: assign.dept_id ? assign.dept_name : ''
                };
                userList.push(assingBean);
              }
              params.work_user = JSON.stringify(userList);
              break;
            // 派单至部门
            case 2:
              if (!this.assignSelectedDept.name) {
                this.showErrorMsg('请选择部门');
                return;
              }
              params.work_department_id = this.assignSelectedDept.id;
              params.work_department_name = this.assignSelectedDept.name;
              break;
          }
          assignOrders(params)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.$router.go(-1);
            })
            .catch((err: any) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          if ((!this.formInformation || !this.formInformation.appointment) && this.appointmentTimeMust) {
            this.showErrorMsg('请选择预约时间');
            return;
          }
          if (this.checkMust()) {
            switch (parseInt(this.selectAssignType)) {
              // 派单工程师
              case 1:
                if (!this.assignSelectedDept.name) {
                  this.showErrorMsg('请选择部门');
                  return;
                }
                if ((this.assignchecked as any).length <= 0) {
                  this.showErrorMsg('请选择工程师');
                  return;
                }
                var userList1: any = [];
                for (const assign of this.assignchecked) {
                  var assingBean = {
                    user_id: assign.user.user_id,
                    name: assign.user.name,
                    dept_id: assign.dept_id ? assign.dept_id : '',
                    dept_name: assign.dept_id ? assign.dept_name : ''
                  };
                  userList1.push(assingBean);
                }
                params.work_user = JSON.stringify(userList1);
                break;
              // 派单至部门
              case 2:
                if (!this.assignSelectedDept.name) {
                  this.showErrorMsg('请选择部门');
                  return;
                }
                params.work_department_id = this.assignSelectedDept.id;
                params.work_department_name = this.assignSelectedDept.name;
                break;
            }
            if (this.taskCoordinationVisble) {
              params.is_assign_other_task_complete = this.taskCoordination ? '1' : '0'
            }
            orderAssign(params)
              .then((res: any) => {
                this.showSuccessMsg(res.msg);
                this.$router.go(-1);
              })
              .catch((err: any) => {
                this.showErrorMsg(err.msg);
              });
          }
        }
        break;
      case 'third':
        if (!this.checkDealPermission(Type.ORDER_TRANSFER)) {
          return;
        }
        // UrlName.ORDERSERVICE_ORDERTRANSFER
        if (!this.formRoll.service) {
          this.showErrorMsg('请选择合作服务方');
          return;
        }
        params.transfer_company_id = (this.formRoll
          .service as any).servicer_company_id;
        params.transfer_company_name = (this.formRoll.service as any).name;
        if (this.isSendOrderToEng === 2) { // 批量处理订单-转单 待确认
          transferOrders(params)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.$router.go(-1);
            })
            .catch((err: any) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          if ((!this.formInformation || !this.formInformation.appointment) && this.appointmentTimeMust) {
            this.showErrorMsg('请选择预约时间');
            return;
          }
          orderTransfer(params)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.$router.go(-1);
            })
            .catch((err: any) => {
              this.showErrorMsg(err.msg);
            });
        }
        break;
    }
  }
  private customerConfirm() {
    if (this.checkMust()) {
      // 确认完成此订单?
      // 当前订单还有1个维修人员未处理完成!
      if ((!this.dynamicRemark || this.dynamicRemark.length < 1) && parseInt(this.remarkModelPermission.v) !== 0) {
        this.showErrorMsg('请填写备注');
        return;
      }
      this.unfinishOrderTaskNum = this.orderDetail.order_service.unfinish_order_task_num;
      this.unfinishOrderTaskVisibility = this.unfinishOrderTaskNum !== 0;
      if (this.unfinishOrderTaskNum === 0) {
        this.orderFinish();
      }
    }
  }
  private orderFinish() {
    if (this.needCheckTask()) {
      this.handleCheck();
      return;
    }
    var finishParams: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: this.orderDetail.order_service.id
    };
    orderFinish(finishParams)
      .then((res: any) => {
        this.unfinishOrderTaskVisibility = false;
        this.showSuccessMsg(res.msg);
        this.$router.go(-1);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private checkMust() {
    if (
      parseInt(this.tagModelPermission.m) === 1 &&
      !(this.formInformation.tags && this.formInformation.tags.length)
    ) {
      this.showErrorMsg(this.tagModelPermission.me);
      return false;
    }
    if (
      parseInt(this.productModelPermission.m) === 1 &&
      !this.formInformation.brand
    ) {
      this.showErrorMsg(this.productModelPermission.me);
      return false;
    }
    if (
      parseInt(this.deviceModelPermission.m) === 1 &&
      !this.formInformation.device
    ) {
      this.showErrorMsg(this.deviceModelPermission.me);
      return false;
    }
    if (
      parseInt(this.partsModelPermission.m) === 1 &&
      !this.formInformation.parts
    ) {
      this.showErrorMsg(this.partsModelPermission.me);
      return false;
    }
    if (
      parseInt(this.picModelPermission.m) === 1 &&
      !(this.formInformation.image && this.formInformation.image.length > 0)
    ) {
      this.showErrorMsg(this.picModelPermission.me);
      return false;
    }
    if (
      parseInt(this.videoModelPermission.m) === 1 &&
      !(this.formInformation.video && this.formInformation.video.length > 0)
    ) {
      this.showErrorMsg(this.videoModelPermission.me);
      return false;
    }
    if (
      parseInt(this.wordModelPermission.m) === 1 &&
      !(this.formInformation.word && this.formInformation.word.length > 0)
    ) {
      this.showErrorMsg(this.wordModelPermission.me);
      return false;
    }
    if (
      parseInt(this.costModelPermission.m) === 1 &&
      !(this.dynamicCost && this.dynamicCost.length > 0)
    ) {
      this.showErrorMsg(this.costModelPermission.me);
      return false;
    }
    if (
      parseInt(this.faultkModelPermission.m) === 1 &&
      !(this.dynamicFault && this.dynamicFault.length > 0)
    ) {
      this.showErrorMsg(this.faultkModelPermission.me);
      return false;
    }
    if (
      parseInt(this.remarkModelPermission.m) === 1 &&
      !(this.dynamicRemark && this.dynamicRemark.length > 0)
    ) {
      this.showErrorMsg(this.remarkModelPermission.me);
      return false;
    }
    if (parseInt(this.diyOneModelPermission.m) === 1 && !this.orderDetail.order.diy_one_content) {
      this.showErrorMsg(this.diyOneModelPermission.me);
      return false;
    }
    if (parseInt(this.diyTwoModelPermission.m) === 1 && !this.orderDetail.order.diy_two_content) {
      this.showErrorMsg(this.diyTwoModelPermission.me);
      return false;
    }
    return true;
  }

  private handleCloseAssign(v: any) {
    let index = this.assignchecked.indexOf(v);
    if (index !== -1) {
      this.assignchecked.splice(index, 1);
    }
  }

  private dealDetailHandle(row: any) {}
  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private assignTableData = [];
  private activeAssignName = 'first';
  private assignOrderTo = {
    type: '1'
  };
  private assignFormSearch = {
    dept: '',
    area: ''
  };
  private assignSelectTableData:any = [];
  private assignSelectAllTableData:any = [];
  private assignSelected = '';
  private assignSelectServiceTableData:any = [];
  private assignchecked: any = [];
  private formRoll = {
    service: ''
  };
  private taskCoordination = ''
  private taskCoordinationDisabled=false;
  private taskCoordinationVisble=false;
  private toOrderList(row:any, taskStage:number) {
    if ((taskStage === 2 && row.task_untreated_count > 0) || (taskStage === 3 && row.task_underway_count > 0)) {
      this.$router.push(
        {
          path: '/OrderServicer/underway',
          query: {
            work_user_id: row.user.user_id,
            task_stage: taskStage + ''
          }
        }
      );
    }
  }
// 详情
private dialogOrderDetailVisible = false;
  private detail = {};
  private orderProgressData = {};
  private isOrderProgress = false;
  private showComplaintBtn=false;
  // 编辑
  private editorOrderHandle(row:any) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todeal',
      query: {
        order_service_id: row.order_service.id,
        company_id: row.order_service.servicer_company_id,
        isEditSendToEng: '1'
      }
    });
    window.open(routeData.href);
  }
  private saveEditSendToEng() {
    window.close();
  }
  // 订单详情
  detailHandle(val: any) {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      order_service_id: val.order_service.id
    };
    getOrderDispose(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.dialogOrderDetailVisible = true;
          this.detail = data;
        }
      })
      .catch((err: any) => {
        let msg = err.msg;
      });

    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.company_id = UserModule.getCompanyId;
    p.order_service_id = val.order_service.id;
    if (val.order.id) {
      p.order_id = val.order.id;
    }
    p.user_name = UserModule.getUserName;
    getOrderServiceProgressList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
        if (
          (this.orderProgressData as any).list &&
          (this.orderProgressData as any).list.length > 0
        ) {
          (this.orderProgressData as any).list[0].color =
            'rgba(185, 235, 247,1)';
        }
        if (
          (this.orderProgressData as any).added_progress &&
          (this.orderProgressData as any).added_progress.length > 0
        ) {
          (this.orderProgressData as any).added_progress[0].color =
            'rgba(185, 235, 247,1)';
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });
  }
  closeDetailHandle(value: boolean) {
    this.dialogOrderDetailVisible = value;
  }

  /**
   * 审核处理
  */
  private configCheck() {
    if (this.needCheckTask()) this.handleCheck();
  }
  private needCheckTask() {
    let priceLimit = this.orderDetail.order.order_check_price_limit;
    if (priceLimit) {
      var totalPrice = 0.0;
      if (this.dynamicCost) {
        for (const item of this.dynamicCost) {
          totalPrice += parseFloat(item.price_num);
        }
      }
      if (this.formInformation.parts) {
        for (const item of this.formInformation.parts) {
          totalPrice += parseFloat(item.parts_price);
        }
      }
      if (this.orderDetail.order.check_state !== '71' && totalPrice >= parseFloat(priceLimit)) {
        return true;
      }
    }
    return false;
  }
  private checkVisible = false;
  private checkModel: any = {
    remark: '',
    title: ''
  }
  private handleCheck() {
    let priceLimit = this.orderDetail.order.order_check_price_limit;
    // let tip = '金额超过' + priceLimit + '元, 请提交审核';
    let tip = '您的订单金额超过限制，请提交审核！';
    this.checkVisible = true;
    this.checkModel.title = tip;
  }
  private clickToCancleCheck() {
    this.checkVisible = false;
  }
  private clickToCheck() {
    if (!this.checkModel.remark) {
      this.showErrorMsg('请填写提审备注');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_id: (this.orderDetail as any).order.id,
      order_service_id: (this.orderDetail as any).order_service.id,
      order_check_is_price: 1,
      remark: this.checkModel.remark
    };
    orderCheck(params).then(res => {
      this.showSuccessMsg('提审成功');
      setTimeout(() => {
        this.$router.go(-1);
      }, 0.8 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
